import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 15,
  },
  text: {
    fontFamily: "open-sans",
    fontSize: 20,
    textAlign: "center",
    color: "#fff",
  },
});

export default styles;
